/**
 * FASE 20.2 — Churches Query Adapter
 */

import { supabase }             from "../../supabase";
import { applyPermissionScope } from "../permissionFilters";

const CHURCH_FIELDS = "id, name, status, family_count, member_count, last_activity_date";

/**
 * Church activity summary for district-level overview.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @returns {Promise<Object[]>}
 */
export async function getChurchActivitySummary(scope) {
  let query = supabase
    .from("vw_churches_with_stats")
    .select(CHURCH_FIELDS)
    .order("last_activity_date", { ascending: false, nullsFirst: false })
    .limit(10);

  // For the view, scope by district_id
  if (scope.level === "district" && scope.district_id) {
    query = query.eq("district_id", scope.district_id);
  } else if (scope.level === "church" && scope.church_id) {
    query = query.eq("id", scope.church_id);
  } else {
    query = query.eq("id", "00000000-0000-0000-0000-000000000000");
  }

  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}
